import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api.js';
import { Loading, Empty, StatusPill, PageHeader, Segmented } from '../../components/ui.jsx';
import Icon from '../../components/Icon.jsx';
import { currency, formatDate, timeRange, STATUS_LABEL } from '../../lib/format.js';

const FILTERS = [
  ['', 'All'],
  ['pending', 'Pending'],
  ['accepted', 'Confirmed'],
  ['completed', 'Completed'],
  ['cancelled', 'Cancelled'],
];

export default function AdminBookings() {
  const [status, setStatus] = useState('');
  const [rows, setRows] = useState(null);

  const load = useCallback(() => {
    setRows(null);
    api.get('/api/admin/bookings', { status }).then(setRows).catch(() => setRows([]));
  }, [status]);

  useEffect(load, [load]);

  return (
    <>
      <PageHeader title="Bookings" subtitle="All platform bookings and their payment state." />

      <Segmented options={FILTERS} value={status} onChange={setStatus} className="mb-3" style={{ maxWidth: 560 }} />

      {!rows ? (
        <Loading rows={3} />
      ) : rows.length === 0 ? (
        <Empty art="empty-bookings" title="No bookings match this filter">
          Change the filter above to see other bookings.
        </Empty>
      ) : (
        <div className="card table-wrap">
          <table className="data">
            <thead>
              <tr>
                <th>#</th>
                <th>Service</th>
                <th>Patient</th>
                <th>Nurse</th>
                <th>When</th>
                <th>Status</th>
                <th>Payment</th>
                <th className="td-right">Amount</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {rows.map((b) => (
                <tr key={b.id}>
                  <td className="dim tiny tabular">{b.id}</td>
                  <td className="nowrap">{b.service_name}</td>
                  <td className="nowrap">{b.patient_name}</td>
                  <td className="nowrap">{b.nurse_name}</td>
                  <td className="nowrap tiny">
                    {formatDate(b.date)}
                    <br />
                    <span className="dim">{timeRange(b.start_time, b.end_time)}</span>
                  </td>
                  <td>
                    <StatusPill status={b.status} label={STATUS_LABEL[b.status]} />
                  </td>
                  <td>
                    <StatusPill
                      status={b.payment_status}
                      label={b.payment_status === 'paid' ? 'Cash collected' : 'Due in cash'}
                    />
                  </td>
                  <td className="bold nowrap td-right">{currency(b.amount)}</td>
                  <td>
                    <div className="row-tight" style={{ justifyContent: 'flex-end' }}>
                      <Link to={`/bookings/${b.id}`} className="btn btn-sm btn-ghost">
                        <Icon name="eye" /> View
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
